import { gql } from '@apollo/client'
import { TRAINING_FRAGMENT } from '../fragments/TrainingFragment'

export const CREATE_TRAINING = gql`
  mutation CreateTraining($input: TrainingInput!) {
    createTraining(input: $input) {
      training {
        ...Training
      }
    }
  }
  ${TRAINING_FRAGMENT}
`
